import { ReactNode } from 'react';
import { formatDecimals } from '@pmp/utils';

import { ReadonlyText } from './ReadonlyText';

type ReadonlyUnit = {
  prefix?: string;
  suffix?: string;
};

type ReadonlyUnitEntity = {
  value: unknown;
  precision?: number;
  [key: string]: unknown;
};

const formatValue = (value: unknown, precision?: number): string =>
  typeof value === 'number' ? formatDecimals(value, precision) : String(value);

// Enso's readonly text drops a field's addonBefore/addonAfter, and on an amount or a percentage that addon is the unit.
export const renderReadonlyWithUnit =
  ({ prefix = '', suffix = '' }: ReadonlyUnit) =>
  (_dom: ReactNode | null, { value, precision }: ReadonlyUnitEntity): ReactNode =>
    value === null || value === undefined || value === '' ? (
      <ReadonlyText value={undefined} />
    ) : (
      <ReadonlyText value={`${prefix}${formatValue(value, precision)}${suffix}`} />
    );
